import AnimatedSection from "./AnimatedSection";
import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import { X, Check } from "lucide-react";

const ComparisonSection = () => {
  const { lang } = useLang();
  const t = translations[lang].comparison;

  return (
    <section id="comparison" data-testid="comparison-section" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <AnimatedSection>
          <div className="text-center mb-14">
            <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-semibold text-electric mb-4 font-body">
              {t.overline}
            </p>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-navy font-heading">
              {t.headline}
            </h2>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <AnimatedSection delay={0.1}>
            <div data-testid="comparison-internal" className="rounded-2xl p-7 bg-slate-50 border border-slate-200 h-full">
              <h3 className="text-lg font-bold text-slate-400 mb-6 font-heading">{t.internal.title}</h3>
              <div className="space-y-4">
                {t.internal.items.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-0.5">
                      <X size={14} className="text-red-400" />
                    </div>
                    <span className="text-slate-500 font-body text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div data-testid="comparison-okontainers" className="comparison-highlight rounded-2xl p-7 h-full relative overflow-hidden">
              <div className="absolute top-0 right-0 w-24 h-24 bg-electric/5 rounded-full -mr-8 -mt-8 blur-2xl" />
              <h3 className="text-lg font-bold text-electric mb-6 font-heading relative z-10">{t.okontainers.title}</h3>
              <div className="space-y-4 relative z-10">
                {t.okontainers.items.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="shrink-0 w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
                      <Check size={14} className="text-emerald-600" />
                    </div>
                    <span className="text-navy font-medium font-body text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
